var map = {
	"./call-chat--mobile.webp": 537,
	"./call-chat.webp": 665,
	"./cursor.webp": 614,
	"./personal-account--mobile.webp": 538,
	"./personal-account.webp": 666,
	"./phone--mobile.webp": 539,
	"./phone.webp": 667
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3076;